import { USER_TYPE_OPTIONS, USERNAME_REGEX } from "./SignUpCard";

describe("SignUpCard user type options", () => {
  it("includes the expected payload values", () => {
    const values = USER_TYPE_OPTIONS.map((option) => option.value);
    expect(values).toEqual(["REGULAR", "ATHLETE"]);
  });

  it("provides the expected labels", () => {
    const labels = USER_TYPE_OPTIONS.map((option) => option.label);
    expect(labels).toEqual(["Regular User", "Athlete"]);
  });

  it("enforces username characters to match backend expectations", () => {
    expect(USERNAME_REGEX.test("valid_user123")).toBe(true);
    expect(USERNAME_REGEX.test("with space")).toBe(false);
    expect(USERNAME_REGEX.test("emoji😀")).toBe(false);
    expect(USERNAME_REGEX.test("punctuation!")).toBe(false);
  });
});
